import { OptionType } from '@/ui/components/Form/Select/types';

export const REQUIREMENT_MET = 'affirmative';
export const REQUIREMENT_FAILED = 'negative';

export const enum TREATABILITY_STATUS {
  TREATABLE = 'treatable',
  NOT_TREATABLE = 'not treatable',
  UNKNOWN = 'unknown',
  WAITLISTED = 'waitlisted'
}

export const enum PRIOR_AUTH_OPTIONS {
  YES = 'yes',
  NO = 'no',
  UNKNOWN = 'unknown'
}

export const enum PAYMENT_TYPE {
  INSURANCE = 'insurance',
  SELF_PAY = 'self-pay'
}

export const PAYMENT_TYPE_OPTIONS: OptionType<string>[] = [
  { value: PAYMENT_TYPE.INSURANCE, label: 'Insurance' },
  { value: PAYMENT_TYPE.SELF_PAY, label: 'Self-Pay' }
];

export const PRIOR_AUTH_OPTIONS_LIST: OptionType<string>[] = [
  { value: PRIOR_AUTH_OPTIONS.YES, label: 'Yes' },
  { value: PRIOR_AUTH_OPTIONS.NO, label: 'Not Required' },
  { value: PRIOR_AUTH_OPTIONS.UNKNOWN, label: 'Unknown' }
];
